import { useContext, useEffect, useState } from "react";
import MainKeeperAPI from "../API/MainKeeperAPI";
import { Context } from "..";
import AssociacionsAPI from "../API/AssociationsAPI";
import GroupsDifficultyAPI from "../API/GroupsDifficultyAPI";

const showLogs = true;
const useMainKeeper = (viewOrganization, taxationSystem, move, docsCount, typeActivity, dropboxesChange) => {

    const { store } = useContext(Context);
    const [tasks, setTasks] = useState([]);
    const [difficulties, setDiff] = useState([]);
    const [hourCost, setHourCost] = useState(0);
    const [currDiscount, setCurrDiscount] = useState(0);

    const [summOrganization, setSummOrg] = useState(0);
    const [summDifficulty, setSummDiff] = useState([0, 0]);

    useEffect(() => {
        loadHourCost().then(() => showLogs && console.log("[✓] Стоимость часа главного бухгалтера загружена"));
        loadTasks().then(() => showLogs && console.log("[✓] Задачи главного бухгалтера получены"));
        loadDifficulties().then(() => showLogs && console.log("[✓] Коэффиценты усложнения главного бухгалтера получены"));
    }, []);
    useEffect(() => {
        if (!tasks || tasks.length === 0) return;

        let orgSumm = mathOrganization(tasks);
        setSummOrg(orgSumm);
    }, [tasks, hourCost, viewOrganization, taxationSystem, move, currDiscount]);
    useEffect(() => {
        if (tasks.length === 0 || difficulties.length === 0) return;

        setSummDiff(mathDifficulties(summOrganization));
    }, [summOrganization, tasks, difficulties, docsCount, typeActivity]);

    const loadHourCost = async () => {
        try {
            const association = await AssociacionsAPI.getAll();
            const result = await store.getPositionInfo(association.data.mainkeeper_id);
            if (result.error === true) throw result;

            setCurrDiscount(result.response ? result.response.discount : 0);
            setHourCost(result.response ? result.response.hoursCost : 0);
        } catch (err) {
            showLogs && console.log("[x] Ошибка в расчетах стоимости часа главного бухгалтера:", err);
            setHourCost(0)
        }
    }
    const loadTasks = async () => {
        try {
            const response = await MainKeeperAPI.getAll();
            if (response.status !== 200) throw response;
            if (!response.data || response.data.length === 0) return;

            setTasks(response.data);
        } catch (err) {
            showLogs && console.log("[x] Ошибка получения задач главного бухгалтера:", err);
        }
    }
    const loadDifficulties = async () => {
        try {
            const response = await GroupsDifficultyAPI.getAll();
            if (response.status !== 200) throw response;
            if (!response.data || response.data.length === 0) return;

            dropboxesChange(response.data);
            setDiff(response.data);
        } catch (err) {
            showLogs && console.log("[x] Ошибка получения коэффицентов усложнения главного бухгалтера:", err);
        }
    }

    const mathOrganization = (taskArray) => {
        try {
            let filtredTask = taskArray.filter(task => task.physical === viewOrganization);
            let summ = 0;
            for (let i = 0; i < filtredTask.length; i++) {
                let task = filtredTask[i];
                let monthTime = task[taxationSystem] / (12 / task.interval);
                summ += monthTime * (hourCost / 60);
            }
            return Math.ceil(summ);
        } catch (err) {
            showLogs && console.log("[x] Ошибка вычисления стоимости модуля \"Компания\" в разделе ГБ:", err);
            return 0;
        }
    }
    const mathDifficulties = (orgSumm) => {
        try {
            let docsList = difficulties.filter(diff => diff.name == "Кол-во документов")[0].param_difficulties;
            let summDocs = docsList.length > 0 ? Math.ceil(orgSumm * docsList[docsCount].value - orgSumm) : 0;
            
            let activityList = difficulties.filter(diff => diff.name == "Вид деятельности")[0].param_difficulties;
            let summActivity = activityList.length > 0 ? Math.ceil(orgSumm * activityList[typeActivity].value - orgSumm) : 0;

            return [summDocs, summActivity];
        } catch (err) {
            showLogs && console.log("[x] Ошибка вычисления стоимости модуля \"Коэффиценты усложнения\" в разделе ГБ:", err);
            return [0, 0];
        }
    }

    return {
        mk_orgranization: summOrganization,
        mk_difficulty_docs: summDifficulty[0],
        mk_difficulty_activity: summDifficulty[1],
        mk_summ: Math.ceil(summOrganization + summDifficulty[0] + summDifficulty[1]),
        mk_changeDiscount: async (newDiscount) => {
            if (newDiscount == undefined) return;
            if (newDiscount == currDiscount) return;
            await loadHourCost();
            setCurrDiscount(newDiscount);
        },
        mk_changeAssociation: async () => {
            await loadHourCost();
        }
    }
}

export default useMainKeeper;
